import _ from 'lodash';
import { axiosInstance } from '../helpers/axios';
import { userService } from './user.service';

export const resourceService = {
  upload,
  findAll,
  _delete,
  userAction,
  findAllInFolder,
  userFolderAction,
  update,
};

function upload(userId, files, query = {}, progressCallback) {
  let formData = new FormData();
  if (!(files instanceof FormData)) {
    files.forEach(file => {
      formData.append('file', file);
    });
  } else {
    formData = files;
  }

  const requestOptions = {
    headers: { 'Content-Type': 'multipart/form-data' },
    // Queue counters are client state; template ownership is a multipart
    // field. The upload endpoint deliberately accepts only type in its query.
    params: { type: query.type },
    onUploadProgress: e => {
      if (e.total > 0 && progressCallback) {
        progressCallback(parseInt((e.loaded / e.total) * 100, 10));
      }
    },
  };

  const url = userId ? `/users/${userId}/resources` : '/resources';
  return axiosInstance
    .post(url, formData, requestOptions)
    .then(handleResponse)
    .then(response => {
      return response;
    })
    .catch(error => {
      if (error.response) return handleResponse(error.response);
      throw error;
    });
}

function findAll(userId, query) {
  const url = userId ? `/users/${userId}/resources` : '/resources';
  return axiosInstance
    .get(url, { params: query })
    .then(handleResponse)
    .then(data => {
      return data;
    })
    .catch(error => {
      handleResponse(error.response);
    });
}

function _delete(userId, resourceId) {
  const url = userId ? `/users/${userId}/resources/${resourceId}` : `/resources/${resourceId}`;
  return axiosInstance
    .delete(url)
    .then(handleResponse)
    .then(data => {
      return data;
    })
    .catch(error => {
      handleResponse(error.response);
    });
}

function userAction(userId, resourceId, action) {
  return axiosInstance
    .post(`/users/${userId}/resources/${resourceId}/${action}`)
    .then(handleResponse)
    .then(data => {
      return data;
    })
    .catch(error => {
      handleResponse(error.response);
    });
}

function findAllInFolder(userId, folderId, query) {
  return axiosInstance
    .get(`/users/${userId}/resources/folders/${folderId}`, { params: query })
    .then(handleResponse)
    .then(data => {
      return data;
    })
    .catch(error => {
      handleResponse(error.response);
    });
}

function userFolderAction(userId, resourceId, folderId, action) {
  return axiosInstance
    .post(`/users/${userId}/resources/${resourceId}/folders/${folderId}/${action}`)
    .then(handleResponse)
    .then(data => {
      return data;
    })
    .catch(error => {
      handleResponse(error.response);
    });
}

function update(id, resource) {
  if (_.has(resource, 'tags') && typeof _.get(resource, 'tags') === 'string') {
    resource.tags = resource.tags ? resource.tags.split(',') : []
  }
  if (_.has(resource, 'tagsFa') && typeof _.get(resource, 'tagsFa') === 'string') {
    resource.tagsFa = resource.tagsFa ? resource.tagsFa.split(',') : []
  }

  const requestOptions = {
    headers: { 'Content-Type': 'application/json' },
    body: resource,
  };

  return axiosInstance
    .patch(`/resources/${id}`, requestOptions.body, requestOptions.headers)
    .then(handleResponse);
}

const handleResponse = response => {
  const data = response.data;
  if (!_.includes([200, 201, 204], response.status)) {
    if (response.status === 401) {
      // auto logout if 401 response returned from api
      userService.logout().then(() => window.location.reload(true));
    }

    const error = (data && data.message) || response.statusText;

    // eslint-disable-next-line no-throw-literal
    throw { status: response.status, error };
  }

  return data;
};
